// extracted by mini-css-extract-plugin
module.exports = {"root":"SendReceipts_root__2x-eS","buttons":"SendReceipts_buttons__2ve1D","email":"SendReceipts_email__SbCp4","bookApptTitle":"SendReceipts_bookApptTitle__3cdlc"};